import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueYouTubeEmbed from 'vue-youtube-embed'


// install router
import router from "./router/index";
// install axios
import axios from 'axios'
import VueAxios from 'vue-axios'
// install keycloak
import VueKeycloakJs from '@dsb-norge/vue-keycloak-js'
import config from "./config.js"

axios.defaults.baseURL = 'https://my.muic.io/api'
// config.apiUrl

Vue.use(VueAxios, axios)

import './appcss/index.css';

Vue.use(VueYouTubeEmbed)
Vue.config.productionTip = false

// not use
// import firebase from 'firebase/app'
// import 'firebase/firestore'
// firebase.initializeApp({
//  Configurações do seu app
// })
// export const db = firebase.firestore()

function tokenInterceptor () {
  axios.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`
    return config
  }, error => {
    return Promise.reject(error)
  })
}

// Vue.use(VueKeycloakJs, {
//   init: {
//     // Use 'login-required' to always require authentication
//     // If using 'login-required', there is no need for the router guards in router.js
//     onLoad: 'check-sso'
//   },
//   config: {
//     url: 'https://sso.muic.io/auth',
//     clientId: 'portal-student',
//     realm: 'IC'
//   },
//   onReady: (keycloak) => {
//     tokenInterceptor()
//     new Vue({
//       vuetify,
//       router,
//       render: h => h(App)
//     }).$mount('#app')
//   }
// })

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
